import { useEffect, useState } from "react"

import { NavLink, useNavigate } from "react-router-dom"

const HomeOutGlosario = () => {

    const navigate = useNavigate();

    return (
        <>
            <div className='home p-0'>
                <div className='container'>
                    <div className="row p-3">
                        <div className="col-12 pt-5">
                            <img src='/assets/img/homeout/CPC-logonuevo 1.png' alt='logo_proteccion_celular'
                                className='mt-4 d-none d-lg-block' style={{ 'width': '200px' }} />
                            <a href="#" onClick={() => navigate(-1)}>
                                <div className="d-lg-none d-block">
                                    <p className="boton-volver mt-5">
                                        <img style={{ width: '25px' }} src='/assets/img/homeout/arrow-back.svg'
                                            className='mx-3 flecha-volver' /></p>
                                </div>
                                <div className="d-none d-lg-block">
                                    <p className="boton-volver mt-5">
                                        <img style={{ width: '25px' }} src='/assets/img/homeout/arrow-back.svg'
                                            className='mx-3 flecha-volver' />VOLVER</p>
                                </div>

                            </a>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="homeout__glosario">
                        <h2 className='color_azul mb-5 text-start'>Glosario de Términos</h2>
                        <ul className="lista-glosario m-md-5 p-md-3" style={{ 'fontSize': '1.5rem' }}>
                            <li>
                                <b>Celular:</b> Equipo de telefonía móvil descrito en la Póliza o el equipo de reemplazo entregado por el fabricante, en caso de ser aplicable su garantía, o por la Compañía en caso de un Evento procedente.
                            </li>
                            <li>
                                <b>Certificado de Cobertura:</b> Documento emitido por la Compañía, el cual contiene la información aplicable a cada Titular del Seguro, referente a los términos bajo los cuales operará el Contrato de Seguro. El Certificado de Cobertura únicamente será expedido en el caso de los seguros adquiridos por el Contratante a instancia de terceros y que sean operados bajo un esquema de colectividad asegurada.
                            </li>
                            <li>
                                <b>Contratante:</b> Persona física o moral que ha celebrado con la Compañía el Contrato de Seguro para sí o para terceras personas y que es responsable de realizar el pago de la prima (salvo que se disponga lo contrario en la Póliza respectiva). En caso de ser una persona moral, también deberá proporcionar la información necesaria y suficiente y generar los reportes y mecanismos para la adecuada operación del Contrato de Seguro.
                            </li>
                            <li>
                                <b>Contrato de Seguro:</b> De forma conjunta: las condiciones generales, la carátula de póliza, la solicitud de seguro, los certificados de cobertura, los endosos y las cláusulas adicionales que se agreguen.
                            </li>
                            <li>
                                <b>Daño accidental:</b> Daño físico al Celular que provenga de un hecho involuntario e imprevisto, que afecte el correcto funcionamiento de éste.
                            </li>
                            <li>
                                <b>Deducible:</b> Participación económica a cargo del Titular del Seguro en caso de la realización del Evento, la cual será pagada por éste previo a la recepción del Beneficio. En caso de aplicar, será el establecido en la Póliza.
                            </li>
                            <li>
                                <b>Evento:</b> Consiste en la ocurrencia de cualquiera de los riesgos indicados como amparados en la Póliza durante la Vigencia.
                            </li>
                            <li>
                                <b>Hurto:</b> Acto cometido por cualquier persona(s) para apoderarse ilícitamente del Celular de forma permanente y sin consentimiento, sin ejercer fuer, violencia y/o intimidación sobre la persona que lo porta.
                            </li>
                            <li>
                                <b>IMEI (International Mobile Equipment Identity):</b> Código pre-grabado en el Celular, que lo identifica de forma exclusiva a nivel mundial.
                            </li>
                            <li>
                                <b>Titular del seguro:</b> Persona física cuyo nombre aparece en la Póliza, que posee la propiedad del Celular y tiene derecho sobre el Beneficio especificado en las coberturas contratadas a consecuencia de la ocurrencia del Evento.
                            </li>
                            <li>
                                <b>Vigencia:</b> Periodo indicado en la póliza, durante el cual el Celular queda cubierto bajo el presente Contrato de Seguro.
                            </li>
                        </ul>
                    </div>
                    <img src='/assets/img/homeout/CPC-logonuevo 1.png' alt='logo_proteccion_celular'
                        className='mt-4 d-block d-lg-none mb-5 mx-auto' style={{ 'width': '200px' }} />
                </div>
            </div>
        </>
    )

}


export default HomeOutGlosario